import { render, staticRenderFns } from "./ShipmentCancelButton.vue?vue&type=template&id=49cbff6b&scoped=true"
import script from "./ShipmentCancelButton.vue?vue&type=script&lang=js"
export * from "./ShipmentCancelButton.vue?vue&type=script&lang=js"
import style0 from "./ShipmentCancelButton.vue?vue&type=style&index=0&id=49cbff6b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cbff6b",
  null
  
)

export default component.exports